<script lang="ts">
	import { ImageLoader } from "carbon-components-svelte";

	let title: string = "Welcome to Botanica!";
</script>

<main>
	<h1>{title}</h1>
	<br />
	<br />
	<p>Created by the jeenus Shadow.</p>
</main>
<img src="assets/programmer.png" alt="The smart programmer" />

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	@media screen and (min-width: 801px) {
		h1 {
			font-size: 80px;
		}
	}

	img {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
		width: 100%;
	}
	/* If the screen size is 600px wide or less, set the font-size of <div> to 30px */
	@media screen and (max-width: 800px) {
		h1 {
			font-size: 25px;
		}
	}
</style>
